// extracted by mini-css-extract-plugin
export default {"root":"yHA9tG","backButton":"LB0DqQ","container":"ZTOXcD","burgerButton":"bOsjXo","logoLink":"HLdVWw","logo":"S3g71o","searchButton":"sdHDdA","fastLinks":"X7HsRG"};